import { useState } from 'react';

interface LockScreenProps {
  onUnlock: (password: string) => Promise<boolean>;
}

export function LockScreen({ onUnlock }: LockScreenProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const ok = await onUnlock(password);
      if (!ok) {
        setError('Incorrect password. Please try again.');
        setPassword('');
        setBusy(false);
      }
    } catch {
      setError('Unlock failed. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="lock-screen">
      <form className="lock-card" onSubmit={handleSubmit}>
        <div className="lock-icon" aria-hidden="true">
          <LockGlyph />
        </div>
        <h1 className="lock-title">App locked</h1>
        <p className="lock-description">
          Enter your password to unlock BioAvail and access your study data.
        </p>

        <div className="lock-field">
          <label className="field-label" htmlFor="unlock-password">
            Password
          </label>
          <input
            id="unlock-password"
            type="password"
            className="text-input"
            value={password}
            autoFocus
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error ? <p className="lock-error" role="alert">{error}</p> : null}

        <div className="lock-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={busy || !password}
          >
            {busy ? 'Unlocking…' : 'Unlock'}
          </button>
        </div>
      </form>
    </div>
  );
}

function LockGlyph() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
